// extracted by mini-css-extract-plugin
export default {"asTable":"table_asTable__W+b07"};